module.exports = __webpack_public_path__ + "static/media/Product Pic-7.f198f486.jpg";